import { render } from "./OverlayRoomType.vue?vue&type=template&id=03f6ce3d&scoped=true"
import script from "./OverlayRoomType.vue?vue&type=script&lang=js"
export * from "./OverlayRoomType.vue?vue&type=script&lang=js"

import "./OverlayRoomType.vue?vue&type=style&index=0&id=03f6ce3d&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f6ce3d"]])

export default __exports__